import {cloneDeep, get, unset} from "lodash";
import {adminCompnaySettingMenu, adminsMenu, hyosungAdminsMenu, hyosungUsersMenu, usersMenu} from "../menu";

const menuRoleMaps = [
    // 관리자 메뉴
    {
        rolePath: 'work.workGroup.access',
        menuPath: 'workingManagement.subMenu.workingGroupManagement',
        menuType: 'admin',
        pathnames: ['/work/group']
    },
    {
        rolePath: 'work.attend.access',
        menuPath: 'workingManagement.subMenu.workingLog',
        menuType: 'admin',
        pathnames: ['/work/log']
    },
    {
        rolePath: 'work.flex.access',
        menuPath: 'workingManagement.subMenu.workingFlexManagement',
        menuType: 'admin',
        pathnames: ['/work/flex']
    },
    /*
    {
        rolePath: 'work.attendHQ.access',
        menuPath: 'workingManagement.subMenu.workingLogHQ',
        menuType: 'admin',
        pathnames: ['/work/logHQ']
    },
    */
    {
        rolePath: 'work.area.access',
        menuPath: 'workingManagement.subMenu.workingPlaceManagement',
        menuType: 'admin',
        pathnames: ['/work/place']
    },
    {
        rolePath: 'work.substitutedRest.access',
        menuPath: 'workingManagement.subMenu.holidayWorkLog',
        menuType: 'admin',
        pathnames: ['/holidayWork/log']
    },
    {
        rolePath: 'work.schedule.access',
        menuPath: 'scheduleManagement.subMenu.workingScheduleManagement',
        menuType: 'admin',
        pathnames: ['/work/schedule']
    },
    {
        rolePath: 'work.schedulePattern.access',
        menuPath: 'scheduleManagement.subMenu.workingSchedulePatternManagement',
        menuType: 'admin',
        pathnames: ['/work/schedulePattern']
    },
    {
        rolePath: 'work.deadline.access',
        menuPath: 'workingManagement.subMenu.workDeadlinePage',
        menuType: 'admin',
        pathnames: ['/work/deadline']
    },
    {
        rolePath: 'user.list.access',
        menuPath: 'memberManagement.subMenu.memberList',
        menuType: 'admin',
        pathnames: ['/member/list']
    },
    {
        rolePath: 'rest.annualLeaveException.access',
        menuPath: 'memberManagement.subMenu.annualLeaveException',
        menuType: 'admin',
        pathnames: ['/rest/annualLeaveException']
    },
    {
        rolePath: 'rest.compensationLeave.access',
        menuPath: 'memberManagement.subMenu.compensationLeave',
        menuType: 'admin',
        pathnames: ['/rest/compensatoryLeave']
    },
    {
        rolePath: 'rest.promote.access',
        menuPath: 'memberManagement.subMenu.anLeavePromotion',
        menuType: 'admin',
        pathnames: ['/anLeavePromotion/list']
    },
    {
        rolePath: 'rest.manage.access',
        menuPath: 'memberManagement.subMenu.restManagement',
        menuType: 'admin',
        pathnames: ['/rest/list']
    },
    {
        rolePath: 'setting.company.access',
        menuPath: 'setting.subMenu.companySetting',
        menuType: 'admin',
        pathnames: ['/company/setting']
    },
    {
        rolePath: 'setting.position.access',
        menuPath: 'positionSettingPage',
        menuType: 'adminCompSetting',
        pathnames: ['/position/setting']
    },
    {
        rolePath: 'setting.rank.access',
        menuPath: 'rankSettingPage',
        menuType: 'adminCompSetting',
        pathnames: ['/rank/setting']
    },
    {
        rolePath: 'setting.holiday.access', // 휴일
        menuPath: 'restSettingPage',
        menuType: 'adminCompSetting',
        pathnames: ['/rest/setting']
    },
    {
        rolePath: 'setting.rest.access', // 휴가
        menuPath: 'vacationSettingPage',
        menuType: 'adminCompSetting',
        pathnames: ['/vacation/setting']
    },
    {
        rolePath: 'setting.work.access',
        menuPath: 'workSystemSettingPage',
        menuType: 'adminCompSetting',
        pathnames: ['/workSystem/setting']
    },
    {
        rolePath: 'setting.role.access',
        menuPath: 'roleSettingPage',
        menuType: 'adminCompSetting',
        pathnames: ['/role/setting']
    },
    {
        rolePath: 'setting.role.access',
        menuPath: 'newRoleSettingPage',
        menuType: 'adminCompSetting',
        pathnames: ['/newRole/setting']
    },
    {
        rolePath: 'setting.role.access',
        menuPath: 'setting.subMenu.departmentManagement',
        menuType: 'admin',
        pathnames: ['/company/department']
    },
    {
        rolePath: 'setting.role.access',
        menuPath: 'setting.subMenu.security',
        menuType: 'admin',
        pathnames: ['/company/security']
    },
    {
        rolePath: 'approval.approval.access',
        menuPath: 'approvalDocument',
        menuType: 'admin',
        pathnames: ['/e-approval']
    },
    {
        rolePath: 'notice.write.access',
        menuPath: 'noticeWrite',
        menuType: 'admin',
        pathnames: ['/board/notice/M/0']
    },
    {
        rolePath: 'setting.workType.access',
        menuPath: 'workTypeSettingPage',
        menuType: 'adminCompSetting',
        pathnames: ['/workType/setting']
    },
    {
        rolePath: 'setting.ip.access',
        menuPath: 'pcAllowedAttendanceIP',
        menuType: 'adminCompSetting',
        pathnames: ['/pcAllowedAttendanceIP/setting']
    },
    {
        rolePath: 'setting.common.access',
        menuPath: 'commonCodeSetting',
        menuType: 'adminCompSetting',
        pathnames: ['/common-code/setting']
    },

    // 사용자 메뉴
    {
        rolePath: 'apply.schedule.access',
        menuPath: 'RequestManagement.subMenu.WorkingSchedule',
        menuType: 'user',
        pathnames: ['/work/calender']
    },
    {
        rolePath: 'apply.compensatoryLeave.access',
        menuPath: 'RequestManagement.subMenu.CompensatoryLeaveManagement',
        menuType: 'user',
        pathnames: ['/compensatory-leave-management']
    },
    {
        rolePath: 'apply.maternity.access',
        menuPath: 'RequestManagement.subMenu.PregnancyApplication',
        menuType: 'user',
        pathnames: ['/pregnancy-application']
    },
    {
        rolePath: 'approval.approval.access',
        menuPath: 'Approval.subMenu.approvalDocument',
        menuType: 'user',
        pathnames: ['/e-approval']
    },
    {
        rolePath: 'status.teamAttend.access',
        menuPath: 'Status.subMenu.WorkingState',
        menuType: 'user',
        pathnames: ['/work/state']
    },
    {
        rolePath: 'status.notice.access',
        menuPath: 'Status.subMenu.Notice',
        menuType: 'user',
        pathnames: ['/board/notice']
    },
]

const filterVisible = (menuObj) =>
    Object.fromEntries(
        Object.entries(menuObj).filter(([_, value]) => !value.hide)
    );

const mergeMenus = (customMenu, coreMenu) => {
    const merged = {};

    // customMenu 우선 순서대로 병합 (subMenu도 병합)
    for (const [key, hVal] of Object.entries(customMenu)) {
        const aVal = coreMenu[key] || {};
        merged[key] = {
            ...hVal,
            subMenu: {
                ...(hVal.subMenu || {}),
                ...(aVal.subMenu
                    ? Object.fromEntries(
                      Object.entries(aVal.subMenu).filter(([k]) => !(hVal.subMenu || {})[k])
                    )
                    : {}),
            },
        };
    }

    // customMenu에 없는 coreMenu 메뉴 추가
    for (const [key, aVal] of Object.entries(coreMenu)) {
        if (!merged[key]) merged[key] = aVal;
    }

    return merged;
};

export const getRoleFilteredMenu = (userMe, menuType) => {
    if (userMe?.id === 0) return {};

    const menuRole = userMe.permissions.menuRole;
    const userMenuRole = userMe.permissions.userMenuRole;

    const maps = menuRoleMaps.filter(v => v.menuType === menuType)
    let menu = {}

    if (menuType === 'admin') {
        let coreMenu;
        if (process.env.REACT_APP_ENV?.includes('hyosung')) {
            coreMenu = filterVisible(adminsMenu);
            menu = mergeMenus(hyosungAdminsMenu, coreMenu);
        } else if (process.env.REACT_APP_ENV === 'saas-prod') {
            menu = cloneDeep(adminsMenu);
        } else if (process.env.REACT_APP_ENV === 'uat') {
            menu = cloneDeep(adminsMenu);
            /*if(userMe.currentCompanyId !== 28){
                coreMenu = filterVisible(adminsMenu);
                menu = mergeMenus(hyosungAdminsMenu, coreMenu);
            }else{
                menu = cloneDeep(adminsMenu);
            }*/
        } else {
            menu = cloneDeep(adminsMenu);
        }
    }
    else if (menuType === 'adminCompSetting') {
        menu = cloneDeep(adminCompnaySettingMenu);
    }
    else if (menuType === 'user') {
        let mergedMenu;
        if (process.env.REACT_APP_ENV?.includes('hyosung')) {
            const hyosungUsersMenuCopy = { ...hyosungUsersMenu };

            // 스케쥴근로제인 경우 외부업무신청 보여지지 않도록
            if (userMe.workSystemName?.trim() === '스케줄근로제') {
              delete hyosungUsersMenuCopy.assumedWorkRequest;
            }

            mergedMenu = { ...filterVisible(usersMenu), ...hyosungUsersMenuCopy };
            menu = cloneDeep(mergedMenu);
        } else if (process.env.REACT_APP_ENV === 'saas-prod') {
            menu = cloneDeep(usersMenu);
        } else if (process.env.REACT_APP_ENV === 'uat') {
            menu = cloneDeep(usersMenu);
            /*if(userMe.currentCompanyId !== 28){
                const hyosungUsersMenuCopy = { ...hyosungUsersMenu };

                // 스케쥴근로제인 경우 외부업무신청 보여지지 않도록
                if (userMe.workSystemName?.trim() === '스케줄근로제') {
                    delete hyosungUsersMenuCopy.assumedWorkRequest;
                }

                mergedMenu = { ...filterVisible(usersMenu), ...hyosungUsersMenuCopy };
                menu = cloneDeep(mergedMenu);
            }else{
                menu = cloneDeep(usersMenu);
            }*/
        } else {
            menu = cloneDeep(usersMenu);
        }
    }

    // 1) 권한 없는 메뉴 제거
    maps.forEach(map => {
        const isUserMenu = map.menuType === 'user';
        const roleSource = isUserMenu ? userMenuRole : menuRole;
        const defaultValue = isUserMenu ? true : undefined;

        if (!get(roleSource, map.rolePath, defaultValue)) {
            unset(menu, map.menuPath);
        }
    });

    // 2) 사용자 메뉴: 하위 메뉴가 전부 사라진 그룹은 그룹째 제거
    //    (hide:true 로 사이드바에 노출되지 않는 항목만 남은 경우도 빈 그룹으로 간주 — 예: 신청·관리 > 연차계획 신청)
    if (menuType === 'user') {
        // menuRoleMaps에 등록된 menuPath에서 그룹 키만 자동 추출 (중복 제거)
        const groupKeys = [...new Set(maps.map(v => v.menuPath.split('.')[0]))];

        groupKeys.forEach((groupKey) => {
            const subMenu = menu[groupKey]?.subMenu;
            if (subMenu && Object.values(subMenu).every(item => item?.hide)) {
                delete menu[groupKey];
            }
        });
    }

    // 환경설정 메뉴 권한이 모두 없는경우, 메뉴에서 제외하도록 함.
    // 근무관리 / 직원 관리에 대해서도 해야 하지만 환경설정만 일단 체크
    if (menuType === 'admin') {
        const hasAnyAccess = (obj, keys) =>
            Object.entries(obj ?? {})
                  .filter(([key]) => !keys || keys.includes(key))
                  .some(([, v]) => v?.access);

        // 근무관리 메뉴의 모든 메뉴에 권한이 없으면 근무관리 제외
        !hasAnyAccess(
            menuRole?.work, Object.keys(menuRole?.work).filter(k => !['schedule', 'schedulePattern'].includes(k))
        ) && unset(menu, 'workingManagement');

        // 스케쥴관리 메뉴의 모든 메뉴에 권한이 없으면 스케쥴관리 제외
        !hasAnyAccess(menuRole?.work, ['schedule', 'schedulePattern']) && unset(menu, 'scheduleManagement');

        // 환경설정의 모든 메뉴에 권한이 없으면 환경설정 제외
        !hasAnyAccess(menuRole?.setting) && unset(menu, 'setting')
    }

    return menu;
}

export const isPermittedPage = (menuRole, pathname, userMenuRole) => {
    const maps = menuRoleMaps.filter(v => v.pathnames.includes(pathname));
    if (!maps.length) return true;

    return maps.some(map => {
        const isUserMenu = map.menuType === 'user';
        const roleSource = isUserMenu ? userMenuRole : menuRole;
        const defaultValue = isUserMenu ? true : undefined;
        return !!get(roleSource, map.rolePath, defaultValue);
    });
}
